import React from "react";

export const SelectAll = ({ size, stroke, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill}
      stroke={stroke || "none"}
      strokeWidth="2px"
      strokeLinecap="round"
    >
      <polygon fill="none" points="45.3 36.8 35.4 36.8 34.5 36.8 31.7 36.8 27.2 36.8 24.5 36.8 23 36.8 5.9 36.8 5.9 13.8 45.3 13.8 45.3 23.5 45.3 24.4 45.3 27.1 45.3 36.8"/>
      <polyline fill="none" points="4.6 33.4 2.4 33.4 2.4 10.4 41.9 10.4 41.9 12.4"/>
      <polyline fill="none" points="17.6 25.9 26 34.3 44 16.3"/>

    </svg>
  );
};
